// Suppress console.log and console.debug in production
// This file should be imported at the very top of the app entry point

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  // Store original functions in case we need them later
  const originalLog = console.log
  const originalDebug = console.debug

  // Suppress log and debug
  console.log = () => {}
  console.debug = () => {}

  // Keep warn and error for important messages
  // console.warn and console.error remain unchanged
}
